import { render } from "./PdfGenerationTest.vue?vue&type=template&id=3aaa60ca&scoped=true"
import script from "./PdfGenerationTest.vue?vue&type=script&lang=js"
export * from "./PdfGenerationTest.vue?vue&type=script&lang=js"

import "./PdfGenerationTest.vue?vue&type=style&index=0&id=3aaa60ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaa60ca"]])

export default __exports__